/* DALY MOUNTAIN — Filter product gallery by color variant (v1.1) */
(function() {
  'use strict';

  function getTemplate() {
    var mainEl = document.querySelector('main[data-template]');
    return mainEl ? mainEl.getAttribute('data-template') : null;
  }
  if (getTemplate() !== 'product') return;

  function detectColorFromMedia(el) {
    var img = el.querySelector('img');
    var alt = (img && img.alt) || el.getAttribute('alt') || '';
    var src = (img && (img.src || img.dataset.src || img.currentSrc)) || '';
    var combined = (alt + ' ' + src).toLowerCase();
    if (/cream/.test(combined) || /hande_canaslan0271|hande_canaslan0269|hande_canaslan0268/.test(combined)) return 'cream';
    if (/light brown|light-brown|lightbrown/.test(combined) || /il_1080xn\.469|il_1080xn\.464/.test(combined)) return 'light-brown';
    return null;
  }

  function tagGalleryItems() {
    // Tag .product-media elements (Horizon slideshow slides)
    var items = document.querySelectorAll('.product-media, slideshow-slide, [class*="product-media"]');
    items.forEach(function(item) {
      if (item.dataset.dmkColor) return;
      var color = detectColorFromMedia(item);
      if (color) {
        item.dataset.dmkColor = color;
        item.classList.add('dmk-color-' + color);
      }
    });
  }

  function getSelectedColor() {
    var picker = document.querySelector('variant-picker, .variant-picker');
    if (!picker) return null;
    var fs = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fs.length; i++) {
      var f = fs[i];
      var legend = f.querySelector('legend, .variant-option__label');
      if (legend && /color/i.test(legend.textContent)) {
        var checked = f.querySelector('input:checked');
        if (checked && checked.value) {
          return checked.value.trim().toLowerCase().replace(/\s+/g, '-');
        }
      }
    }
    return null;
  }

  function applyFilter() {
    tagGalleryItems();
    var color = getSelectedColor();
    if (!color) return false;
    document.body.dataset.dmkActiveColor = color;
    var items = document.querySelectorAll('[data-dmk-color]');
    if (items.length === 0) return false;
    var foundMatch = false;
    items.forEach(function(item) {
      if (item.dataset.dmkColor === color) {
        item.classList.remove('dmk-hidden-by-color');
        foundMatch = true;
      } else {
        item.classList.add('dmk-hidden-by-color');
      }
    });
    return foundMatch;
  }

  // Aggressive polling for first 5 seconds (in case picker renders late)
  var pollCount = 0;
  var pollInterval = setInterval(function() {
    pollCount++;
    applyFilter();
    if (pollCount >= 10) clearInterval(pollInterval);
  }, 500);

  // Watch variant picker changes
  function bindPicker() {
    var picker = document.querySelector('variant-picker, .variant-picker');
    if (!picker) { setTimeout(bindPicker, 300); return; }
    if (picker.dataset.dmkBound) return;
    picker.dataset.dmkBound = '1';
    picker.addEventListener('click', function() { setTimeout(applyFilter, 50); }, true);
    picker.addEventListener('change', function() { setTimeout(applyFilter, 50); }, true);
    var mo = new MutationObserver(function() { setTimeout(applyFilter, 30); });
    mo.observe(picker, { attributes: true, childList: true, subtree: true });
  }
  bindPicker();

  // Watch URL changes
  var lastUrl = location.href;
  setInterval(function() {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(applyFilter, 200);
    }
  }, 400);

  // Initial call
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFilter);
  } else {
    applyFilter();
  }
})();
